import * as ActionTypes from "./actionTypes";

export function setActivePage(page) {
  return { type: ActionTypes.SET_ACTIVE_PAGE, payload: page };
}

export function setPager(page, totalPages) {
  return {
    type: ActionTypes.SET_PAGER,
    payload: { activePage: page, totalPages: totalPages }
  };
}
